"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardEmbed = void 0;
var react_1 = __importDefault(require("react"));
var injectHttps_1 = require("../../../utils/injectHttps");
var ImageInput_1 = require("../../ImageInput");
var styled_components_1 = require("styled-components");
var MetaBlock_1 = __importDefault(require("../../MetaBlock"));
var styled_1 = require("../styled");
var styled_2 = require("./styled");
var utilsOolib_1 = require("../../../utilsOolib");
var Typo_1 = require("../../Typo");
var VideoInput_1 = __importDefault(require("../../VideoInput"));
var LineClampWrapper_1 = require("../comps/LineClampWrapper");
var decideLinkCompAndTarget_1 = require("../utils/decideLinkCompAndTarget");
var dontRenderIfBothOnClickAndTo_1 = require("../utils/dontRenderIfBothOnClickAndTo");
var mediaDataExists_1 = require("../utils/mediaDataExists");
var parseCardConfig_1 = require("../utils/parseCardConfig");
var CardPlaceholder_1 = require("../comps/CardPlaceholder");
// const ErrorEmbedComp = ({ to }) => {
//   return (
//     <ErrorCardEmbedWrapper>
//       <StyledEmbedCardWrapper>
//         <StyledContentModule1 error={true}>
//           <PaddingTopBottom20>
//             {to && <StyledCardEmbedLink>{to}</StyledCardEmbedLink>}
//           </PaddingTopBottom20>
//         </StyledContentModule1>
//       </StyledEmbedCardWrapper>
//     </ErrorCardEmbedWrapper>
//   );
// };
var CardEmbed = function (_a) {
    var id = _a.id, data = _a.data, config = _a.config, to = _a.to, onClick = _a.onClick, openInNewTab = _a.openInNewTab, 
    // status, //i dont think this should exist in this manner
    disabled = _a.disabled, //usecase: rte embed link modal if link is invalid
    urlInsteadOfMetaBlock = _a.urlInsteadOfMetaBlock //this is a anomaly. only used for CardLinkInput wherein we need to show an 'external link' instead of the metablock
    ;
    var theme = (0, styled_components_1.useTheme)();
    var parseSpecialSyntax = (theme || {}).parseSpecialSyntax;
    /**
     * why do we have imageAspectRatio?
     * because, ideally the og imageInput comp's aspect ratio should be supplied to this component
     * so that the image is appropriately positioned within the image container mask of this comp
     */
    var _b = (0, parseCardConfig_1.parseCardConfig)({
        config: config,
        data: data,
        parseSpecialSyntax: parseSpecialSyntax,
    }), cardLabel = _b.cardLabel, title = _b.title, video = _b.video, image = _b.image, _c = _b.imageAspectRatio, imageAspectRatio = _c === void 0 ? '5/3' : _c, metaBlock = _b.metaBlock;
    var dontRenderRes = (0, dontRenderIfBothOnClickAndTo_1.dontRenderIfBothOnClickAndTo)({ onClick: onClick, to: to });
    if (dontRenderRes)
        return dontRenderRes;
    var _d = (0, decideLinkCompAndTarget_1.decideLinkCompAndTarget)({
        to: to,
        openInNewTab: openInNewTab,
    }), LinkComp = _d.LinkComp, target = _d.target, externalUrl = _d.externalUrl;
    var mediaConfigExists = config.video || config.image;
    // if (status === "error") return <ErrorEmbedComp to={to} />;
    return (react_1.default.createElement(LinkComp, { target: target, href: (0, injectHttps_1.injectHttps)(to), to: to },
        react_1.default.createElement(styled_2.StyledEmbedCardWrapper, { id: id, disabled: disabled, onClick: onClick ? function (e) { return onClick(e, data); } : undefined },
            react_1.default.createElement(styled_2.StyledContentModule1, { mediaConfigExists: mediaConfigExists },
                cardLabel && (react_1.default.createElement("div", { style: { paddingBottom: "0.7rem" }, title: cardLabel },
                    react_1.default.createElement(styled_1.StyledLabel, { disabled: disabled, color: (0, utilsOolib_1.getPrimaryColorText)(theme === null || theme === void 0 ? void 0 : theme.colors) }, cardLabel))),
                title && (react_1.default.createElement(LineClampWrapper_1.LineClampWrapper, { noOfLines_M: 1, noOfLines_D: 2, title: title },
                    react_1.default.createElement(styled_1.StyledTitle, { disabled: disabled, as: Typo_1.SERIF_3_4, capitalize: true, className: "StyledTitle" },
                        react_1.default.createElement(styled_1.StyledTitleSpan, { className: "StyledTitleSpan" }, title)))),
                (urlInsteadOfMetaBlock || (metaBlock === null || metaBlock === void 0 ? void 0 : metaBlock.length) > 0) && react_1.default.createElement("div", { style: { paddingTop: "1.7rem" } }, urlInsteadOfMetaBlock
                    ? react_1.default.createElement(styled_2.StyledCardEmbedLink, null, urlInsteadOfMetaBlock)
                    : (metaBlock === null || metaBlock === void 0 ? void 0 : metaBlock.length) > 0 && react_1.default.createElement(MetaBlock_1.default, { disabled: disabled, config: metaBlock, data: data }))),
            mediaConfigExists && (react_1.default.createElement(styled_2.StyledContentModule2, { disabled: disabled },
                !(0, mediaDataExists_1.imageDataExists)(image) && !(0, mediaDataExists_1.videoDataExists)(video) && (react_1.default.createElement(styled_2.StyledCardEmbedPlaceholderWrapper, null,
                    react_1.default.createElement(CardPlaceholder_1.CardPlaceholder, { style: {
                            position: "absolute",
                            left: "50%",
                            transform: "translateX(-50%)",
                            height: "100%",
                            width: "auto",
                        } }))),
                (0, mediaDataExists_1.videoDataExists)(video) && !(0, mediaDataExists_1.imageDataExists)(image) ? (react_1.default.createElement(styled_2.StyledMediaContainer, null,
                    react_1.default.createElement("div", { style: {
                            position: "relative",
                            height: "100%",
                            width: "23rem" /** arbitrary num just to get a typical youtube video to fit properly within the mask */,
                        } },
                        react_1.default.createElement(VideoInput_1.default, { value: video, readOnly: true, light: true, height: "100%" }),
                        react_1.default.createElement("div", { style: {
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                            } })))) : null,
                (0, mediaDataExists_1.imageDataExists)(image) && (react_1.default.createElement(styled_2.StyledMediaContainer, null,
                    react_1.default.createElement(ImageInput_1.ImageInput, { stretchToFullHeight: true, value: image, aspectRatio: imageAspectRatio, readOnly: true, enableCaptions: false, disableImageBorder: true, defaultImageSpread: "cover" }))))))));
};
exports.CardEmbed = CardEmbed;
